import { routeNames } from '@/router/names.ts'

export const CHILD_PROTECT_DOCUMENT = 'child_protect_required'
export const CURRENT_TERMS_DOCUMENT = 'terms_acceptance_required'

export type RequiredDocumentCode = typeof CHILD_PROTECT_DOCUMENT | typeof CURRENT_TERMS_DOCUMENT

export const routeNamesByDocumentCode = {
    [CHILD_PROTECT_DOCUMENT]: routeNames.CHILD_PROTECTION_VIEW_NAME,
}
